import React, { useEffect} from "react";
import { Row, Form } from "react-bootstrap";

import { useGlobalState } from '../../components/globalStateProvider.js';
import { machineListSelectedAPI } from '../../api/api_definitions.js';


const MachineFamilyList = () => {

    const {machineFamily, setMachineFamily, setListCustomerMachines, setCustomerName } = useGlobalState();

    // Reset the info
    useEffect(() => {
      setCustomerName("");
    }, [machineFamily]);
 
    // API GATEWAY RESPONSE MANAGEMENT --> Return list of machines according to their type
    useEffect(() => {
      let isMounted = true;
      machineListSelectedAPI(machineFamily)
      .then((dataAPI) => {
          if (isMounted) {
          if (dataAPI !== null) {
              setListCustomerMachines(dataAPI.ListMachines)        
            }
          }
      })
      .catch((error) => {
        console.log(error);
      });
      return () => {
        isMounted = false;
      };
    }, [machineFamily, setListCustomerMachines])

    // Return layout
    return (
      <>
        <Row>
          <Form.Select
            aria-label="Default select example"
            as="select"
            value={machineFamily}
            onChange={e => {
              if (e.target.value !== "0") {
                setMachineFamily(e.target.value);
              }
            }}>
            <option value="0" disabled>Seleziona la famiglia macchina</option>
            <option value="1">Laser Genius +</option>
            <option value="2">Laser Genius Fiber</option>
            <option value="3">Platino Fiber</option>
            <option value="4">Platino Linear</option>
          </Form.Select>
        </Row>
      </>  
    );
};

export default MachineFamilyList;